/* eslint-disable no-underscore-dangle */
import type { MeetingsQuickSwitcherData, QuickSwitcherData } from '@ps/web-sports-api-types';

export const isMeetingBasedQuickSwitcherData = (
  data?: QuickSwitcherData
): data is MeetingsQuickSwitcherData => data?._type === 'MEETINGS';
